import withAPIAction from 'helpers/withAPIAction'
import {
  TaxListReq,
  CreateTaxReq,
  UpdateTaxReq,
  DeleteTaxReq,
  TaxDetailReq,
  GetMerchantTaxReq,
  UpdateMerchantTaxReq,
  CreateTaxSupplierReq,
  GetAllCustomerTaxReq,
} from './types'
import {
  getTaxListAction,
  createTaxAction,
  updateTaxAction,
  deleteTaxAction,
  getTaxDetailAction,
  getMerchantTaxAction,
  updateMerchantTaxAction,
  createTaxSupplierAction,
  getAllCustomerTaxListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const taxListAPI = (data: TaxListReq, token: string, xmid: any) => {
  return withAPIAction<TaxListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.taxList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getTaxListAction)
}

export const createTaxAPI = (data: CreateTaxReq, token: string, xmid: any) => {
  return withAPIAction<CreateTaxReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createTax,
    data,
    token,
    xmid,
  })(createTaxAction)
}

export const createTaxSupplierAPI = (data: CreateTaxSupplierReq, token: string, xmid: any) => {
  return withAPIAction<CreateTaxSupplierReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createTaxSupplier,
    data,
    token,
    xmid,
  })(createTaxSupplierAction)
}

export const updateTaxAPI = (data: UpdateTaxReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateTax.replace(':id', data.id.toString())
  return withAPIAction<UpdateTaxReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateTaxAction)
}

export const deleteTaxAPI = (data: DeleteTaxReq, token: string, xmid: string) => {
  return withAPIAction<DeleteTaxReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deleteTax,
    data,
    token,
    xmid,
  })(deleteTaxAction)
}

export const getTaxDetailAPI = (
  data: TaxDetailReq,
  token: string,
  xmid: any,
  isSupplier: boolean = false,
) => {
  let endPoint = ''
  if (isSupplier) {
    endPoint = APIPath.getSupplierTaxByID.replace(':id', data.id.toString())
  } else {
    endPoint = APIPath.getTaxByID.replace(':id', data.id.toString())
  }

  return withAPIAction<TaxDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getTaxDetailAction)
}

export const getMerchantTaxAPI = (data: GetMerchantTaxReq, token: string, xmid: any) => {
  return withAPIAction<GetMerchantTaxReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getMerchantTax}`,
    data,
    token,
    xmid,
  })(getMerchantTaxAction)
}

export const updateMerchantTaxAPI = (data: UpdateMerchantTaxReq, token: string, xmid: any) => {
  return withAPIAction<UpdateMerchantTaxReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.updateMerchantTax}`,
    data,
    token,
    xmid,
  })(updateMerchantTaxAction)
}

export const getAllCustomertaxListAPI = (data: GetAllCustomerTaxReq, token: string, xmid: any) => {
  return withAPIAction<GetAllCustomerTaxReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.customerTaxList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllCustomerTaxListAction)
}
